module.exports = "#version 100\nprecision highp float;\n\nuniform mat4 u_viewProjectionMatrix;\n\nattribute vec3 a_position;\nattribute vec3 a_normal;\nattribute vec2 a_uv;\n\nvarying vec3 v_position;\nvarying vec3 v_normal;\nvarying vec2 v_uv;\n\nvoid main() {\n    gl_Position = u_viewProjectionMatrix * vec4(a_position, 1.0);\n    v_position = a_position;\n    v_normal = a_normal;\n    v_uv = a_uv;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/forwardPlus.vert.glsl
// module id = 30
// module chunks = 0